import { ReactComponent as ArrowLeftIcon } from '../../assets/icons/arrow-left.svg';
import { ReactComponent as CloseIcon } from '../../assets/icons/close.svg';
import { ReactComponent as PasswordHideIcon } from '../../assets/icons/password-hide.svg';
import { ReactComponent as PasswordShowIcon } from '../../assets/icons/password-show.svg';
import { ReactComponent as TrashNewIcon } from '../../assets/icons/trash-new.svg';
import { IButtonIcon } from '../interfaces/buttons';

export const CLOSE_ICON: IButtonIcon = {
  component: CloseIcon
};

export const ARROW_LEFT_ICON: IButtonIcon = {
  component: ArrowLeftIcon
};

export const PASSWORD_SHOW_ICON: IButtonIcon = {
  component: PasswordShowIcon
};

export const PASSWORD_HIDE_ICON: IButtonIcon = {
  component: PasswordHideIcon
};

export const TRASH_ICON: IButtonIcon = {
  component: TrashNewIcon
};
